import {
  FORM_CONTAINER_COMPONENT_TYPE,
  FORM_RESOURCE_TYPES,
  type FormResourceType,
} from './form-contract';

export {
  FORM_CONTAINER_COMPONENT_TYPE,
  FORM_RESOURCE_TYPES,
  type FormResourceType,
};

const formResourceTypeSet = new Set<string>(Object.values(FORM_RESOURCE_TYPES));

export const isFormContainerResourceType = (
  resourceType: unknown,
): resourceType is typeof FORM_RESOURCE_TYPES.container =>
  resourceType === FORM_RESOURCE_TYPES.container;

export const isFormResourceType = (
  resourceType: unknown,
): resourceType is FormResourceType =>
  typeof resourceType === 'string' && formResourceTypeSet.has(resourceType);

export const formComponentTypeFromResourceType = (
  resourceType: string,
): string => {
  if (resourceType === FORM_RESOURCE_TYPES.container) {
    return FORM_CONTAINER_COMPONENT_TYPE;
  }

  const name = resourceType.split('/').pop();
  return name ? `form-${name}` : '';
};
